import PhysicianTopCard from './components/PhysicianTopCard';
import PhysicianTabs from './components/tabs/PhysicianTabs';
import { useEffect, useState } from 'react';
import { getPhysician, getPhysicianExpertises } from './api';
import { APIProvider } from '@vis.gl/react-google-maps';
import PhysicianRoast from './components/PhysicianRoast';
import PhysicianSearch from './components/PhysicianSearch';

export default function App() {
  const questParams = new URLSearchParams(window.location.search)
  const [currentPhysician, setCurrenPhysician] = useState();
  const [allPractices, setAllPractices] = useState();
  const [showRoast, setShowRoast] = useState(false);
  const [searchNpi, setSearchNpi] = useState(null);

  useEffect(() => {
    const loadPhysicianBasicInfo = async () => {
      console.log(searchNpi);
      let npi = null;
      if (!searchNpi) {
        if (questParams.get('npi')) {
          npi = questParams.get('npi');
          setSearchNpi(npi);
        }

      }
      if(searchNpi) {
        
        const physicianData = await getPhysician(searchNpi);
        const dkwdata = await getPhysicianExpertises(searchNpi);
        // console.log(physicianData);
        
        if (physicianData?.cmsNpiList.length > 0) {
          const physicianObj = physicianData.cmsNpiList[0];
          if (dkwdata?.npiDkws.length > 0) {
            physicianObj['dkws'] = dkwdata.npiDkws;
          }
          setAllPractices([...physicianData.cmsNpiList]);
          setCurrenPhysician({ ...physicianObj });
        }

        if (questParams.get('showRoast')) {
          setShowRoast(true);
        }
      }      
    }
    loadPhysicianBasicInfo();
  }, [searchNpi]);

  const handlePhysicianSearch = (xnpi) => {
    setSearchNpi(xnpi);
    setShowRoast(true);
  };

  return (
    currentPhysician ? <APIProvider apiKey={"AIzaSyDKhjLxJXb4x2cKu5dlrCqTphk-LmuaFys"}>
      {showRoast && <PhysicianRoast currentPhysician={currentPhysician} />}
    </APIProvider> :<PhysicianSearch onSearch={handlePhysicianSearch} />
  );
}
